function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import * as cookies from '@upgrade/ui-utils/utils/cookies';
import { getRootDomain } from '@upgrade/ui-utils/utils/get-domain';
import { unescapeHtmlEntities, condenseAndNormalizeWhitespaces, removeNonASCII } from '@upgrade/ui-utils/parsers/normalize-string';
import { parse, stringify } from 'query-string';
import sha from 'sha.js/sha256';
import { v4 as uuid } from 'uuid';
import { getSearch, getHref } from './utils/location';

// We want the the cookies to expire thirty days from creation date
var COOKIE_EXPIRES_SECONDS = 30 * 24 * 60 * 60;
var BLACKLIST_URLS = ['/portal/login'];
var BLACK_LIST_PARAMS = ['borrowerFirstName', 'borrowerLastName', 'borrowerStreet', 'username', 'password', 'email'];

// deduplicate query string params by default. array values should use format name[]=foo&name[]=bar
export var getUrlParams = function getUrlParams() {
  return parse(getSearch(), {
    arrayFormat: 'bracket'
  });
};
export var getSanitizedUrl = function getSanitizedUrl(url) {
  var splittedUrl = url.split('?');
  if (BLACKLIST_URLS.some(function (u) {
    return url.includes(u);
  })) {
    return splittedUrl[0];
  }
  var urlParams = parse(splittedUrl[1], {
    sort: false
  });
  BLACK_LIST_PARAMS.forEach(function (param) {
    if (urlParams[param]) {
      delete urlParams[param];
    }
  });
  var sanitizedParams = stringify(urlParams, {
    sort: false
  });
  return "".concat(splittedUrl[0]).concat(sanitizedParams ? "?".concat(sanitizedParams) : '');
};
var getCookieId = function getCookieId() {
  return uuid();
};
var getSessionId = function getSessionId() {
  return uuid();
};
var getDeviceId = function getDeviceId() {
  return new sha().update("".concat(window.navigator.userAgent).concat(window.navigator.language) + "sessionStorage:".concat(Boolean(window.sessionStorage).toString()) + "localStorage:".concat(Boolean(window.localStorage).toString())).digest('hex');
};
var getSubId = function getSubId(params) {
  // subId should be case insensitive
  var subId = '';
  var subIdRegex = /sub_id|subid/i;
  Object.keys(params).forEach(function (key) {
    if (key.match(subIdRegex)) {
      subId = params[key];
    }
  });
  return subId;
};
export var getRasProperties = function getRasProperties(action, loanId, params) {
  return {
    ras_action: action,
    ras_asset_id: loanId,
    ras_device_v1: getDeviceId(),
    ras_page_url: getSanitizedUrl(getHref()),
    ras_timestamp: new Date().toDateString(),
    rp_code: params.rp_code,
    sub_id: getSubId(params),
    utm_campaign: params.utm_campaign,
    utm_content: params.utm_content,
    utm_medium: params.utm_medium,
    utm_source: params.utm_source,
    utm_term: params.utm_term,
    sharedid: params.sharedid,
    partner_offer_id: params.partner_offer_id || params.ltprequalOfferId || params.ltprequalofferid,
    modelid: params.modelid,
    income: params.income,
    retailltv: params.retailltv,
    vehicleage: params.vehicleage,
    mileage: params.mileage
  };
};
export var setUuidCookie = function setUuidCookie() {
  var opt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var cookieId = (opt === null || opt === void 0 ? void 0 : opt.cookieId) || getCookieId();
  return cookies.set('ras_cookie_uuid', cookieId, _objectSpread({
    domain: getRootDomain(),
    secondsToExpire: COOKIE_EXPIRES_SECONDS
  }, opt));
};
export var setSessionCookie = function setSessionCookie() {
  return sessionStorage.setItem('ras_session_id', getSessionId());
};
export var getUuidCookie = function getUuidCookie() {
  return cookies.get('ras_cookie_uuid');
};
export var getSessionCookie = function getSessionCookie() {
  return sessionStorage.getItem('ras_session_id') || undefined;
};
export var getPropertiesCookie = function getPropertiesCookie() {
  return cookies.getJSON('ras_properties') || {};
};
export var ensureUuidCookies = function ensureUuidCookies() {
  var cookieOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  if (!getUuidCookie()) {
    setUuidCookie(cookieOptions);
  }
  if (!getSessionCookie()) {
    setSessionCookie();
  }
};
export var cleanSpecialCharFromString = function cleanSpecialCharFromString(str) {
  var unescapedStr = unescapeHtmlEntities(str);
  var decoded = decodeURI(unescapedStr);
  var sanitizedStr = removeNonASCII(decoded);
  return condenseAndNormalizeWhitespaces(sanitizedStr);
};
var mergeAndSetCookieProperties = function mergeAndSetCookieProperties(freshProperties) {
  var opt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var oldProperties = getPropertiesCookie();
  var utmKeys = ['utm_source', 'utm_content', 'utm_medium', 'utm_term', 'utm_campaign'];
  var properties = _objectSpread(_objectSpread(_objectSpread({}, oldProperties), freshProperties), utmKeys.reduce(function (acc, key) {
    return freshProperties[key] ? _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, key, cleanSpecialCharFromString(freshProperties[key]))) : acc;
  }, {}));
  cookies.set('ras_properties', properties, _objectSpread({
    secondsToExpire: COOKIE_EXPIRES_SECONDS
  }, opt));
};
var getCurrentRasPropertiesThatHaveValue = function getCurrentRasPropertiesThatHaveValue(action, loanId) {
  var freshProperties = getRasProperties(action, loanId, getUrlParams());
  return _objectSpread({}, Object.keys(freshProperties).filter(function (key) {
    return Boolean(freshProperties[key]);
  }).reduce(function (obj, key) {
    return _objectSpread(_objectSpread({}, obj), {}, _defineProperty({}, key, freshProperties[key]));
  }, {}));
};
export var setPropertiesCookie = function setPropertiesCookie(action, loanId) {
  var opt = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  mergeAndSetCookieProperties(getCurrentRasPropertiesThatHaveValue(action, loanId), opt);
};
export var overridePropertiesCookie = function overridePropertiesCookie(customProperties) {
  var opt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  mergeAndSetCookieProperties(customProperties, opt);
};
export var setLoginCookies = function setLoginCookies(loanId) {
  ensureUuidCookies();
  setPropertiesCookie('login', loanId);
};